(function($){
	//Only run if there's a filter form on the page
	if ($("#filter-form").length) {

		//Mobile filter term reveal
		$( '.filter-sidebar-mobile' ).click( function( e ) {
			$( '.filter-sidebar' ).slideToggle( "slow" );
			$(this).toggleClass('active');
		});

		//Append sorting if there is a sort select
		if ($('#sort-select').length) {

			//Set initial values
			setOrder();

			//Listen for changes
			$('#sort-select').change(function(e) {
				//Set new values
				setOrder();

				//Reset the page
				$('#paged').val(1);

				//Submit the form
				$('#filter-form').trigger('submit');
			});

			function setOrder() {
				//Get the current sort option
				let $selected = $('#sort-select option:selected');

				$('#order').val($selected.attr('data-order'));
				$('#orderby').val($selected.attr('data-orderby'));
			}
		}
	}

})(jQuery);
